<div class="empty-state">
  <div class="mat-headline-4 queue-setup-title">Manage calls with queues</div>
  <div class="mat-body-2 queue-setup-text">
    ACD (Automatic Call Distribution) queues help inbound contact centers manage call volume by
    automatically receiving incoming calls and distributing them to available agents.
  </div>
  <button
    mat-flat-button
    [routerLink]="viewsLink"
    [attr.data-cy]="e2Locator"
    color="primary"
    class="queue-setup-button"
  >
    Add ACD queue
  </button>
  <div class="mat-body-2 queue-pricing">
    {{ pricingText }}
  </div>
</div>
